var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loadedCoupon,
          expression: "loadedCoupon",
        },
      ],
      staticClass: "coupon rounded-lg flex-column h-100 coupon-border p-3",
    },
    [
      _c("div", { staticClass: "flex-grow" }, [
        _c(
          "div",
          { staticClass: "coupon-header d-flex flex-column xs-flex-row " },
          [
            _vm.isCreditPackage
              ? _c("div", {
                  staticClass:
                    "align-self-center xs-align-self-start coupon-icon coupon-credits",
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isCreditPackage
              ? _c(
                  "div",
                  [
                    _vm.isVivaincontri
                      ? _c("svg-coupon-vivaincontri")
                      : _c("div", {
                          staticClass:
                            "align-self-center xs-align-self-start coupon-icon coupon-up",
                        }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "m-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "mx-auto xs-mx-0 my-auto " }, [
              _c(
                "div",
                {
                  staticClass:
                    "coupon-title text-xs sm-text-sm md-text-base pb-1",
                },
                [
                  _c(
                    "h5",
                    {
                      staticClass:
                        "text-gray-700 font-weight-normal d-inline text-size-inherit",
                    },
                    [_vm._v(_vm._s(_vm.trans.coupon))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold " }, [
                    _vm._v(_vm._s(_vm.coupon.type_title)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "coupon-subtitle text-blue-600 text-lg sm-text-xl lg-text-2xl leading-4",
                },
                [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "font-weight-bold m-0 d-inline text-size-inherit",
                    },
                    [_vm._v(_vm._s(_vm.coupon.title))]
                  ),
                  _vm._v(" "),
                  _vm.isCttProduct
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "font-weight-bold text-lg sm-text-xl lg-text-2xl text-pink-600 text-sm sm-text-base lg-text-lg",
                        },
                        [_vm._v(_vm._s(_vm.coupon.product.value))]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.coupon.description
                ? _c(
                    "div",
                    { staticClass: "coupon-description pt-1 pt-sm-0 text-xs" },
                    [
                      _c("span", { staticClass: "font-weight-light" }, [
                        _vm._v(_vm._s(_vm.coupon.description)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-2" }),
      _vm._v(" "),
      !this.isCttProduct ? _c("hr", { staticClass: "m-0" }) : _vm._e(),
      _vm._v(" "),
      this.isCttProduct
        ? _c("div", { staticClass: "form-group mt-4 mb-2" }, [
            _c("div", { staticClass: "mt-0 mb-2" }, [
              _c("span", { staticClass: "text-muted day" }, [
                _vm._v(_vm._s(this.time_range)),
              ]),
            ]),
            _vm._v(" "),
            _vm.isPromotePage
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.productCode,
                        expression: "productCode",
                      },
                    ],
                    ref: "select",
                    staticClass: "browser-default custom-select",
                    attrs: {
                      tabindex: "-1",
                      "data-toggle": "popover",
                      "data-trigger": "manual",
                      "data-content": _vm.templateTrans
                        ? _vm.templateTrans[0]
                        : "",
                      "data-placement": "bottom",
                      disabled: !_vm.$parent.couponSelected,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.onSelectChange.apply(null, arguments)
                      },
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.productCode = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.templateTrans ? _vm.templateTrans[0] : "")
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.timeIntervals, function (interval) {
                      return _c(
                        "option",
                        { domProps: { value: interval.ctt_product_id } },
                        [
                          _vm._v(
                            _vm._s(interval.start) +
                              " - " +
                              _vm._s(interval.end) +
                              "\n      "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mt-3 coupon-footer d-flex justify-content-between align-items-center",
        },
        [
          _vm.isCreditPackage
            ? _c("use-coupon", {
                attrs: {
                  "url-use-coupon": _vm.urlUseCoupon,
                  id: _vm.coupon.id,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isCttProduct || _vm.isAddons
            ? _c(
                "div",
                {
                  staticClass:
                    "coupon-subtitle text-blue-600 text-lg sm-text-xl lg-text-2xl leading-4",
                },
                [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "text-blue-600 font-weight-light text-base m-0 d-block leading-3",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.trans.can_use_it_when_promoting) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mx-2" }),
          _vm._v(" "),
          _c("div", { staticClass: "  d-flex flex-column align-self-center" }, [
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.trans.expires_on) + ":"),
            ]),
            _vm._v(" "),
            _c("small", {}, [_vm._v(_vm._s(_vm.coupon.valid_to))]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }